import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
const barcodeLabelStore = {
  namespaced: true,
  state: {
  },
  actions: {
    getBarcode({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/ItemBarcodes", { fritem: param.fritem, toItem: param.toItem })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getItemLabel({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/ItemLabel", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //Post Api
    saveItemLabel({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/item/SaveItemLabel",
          JSON.stringify({
            itemLabel: param.model,
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteItemBarcodeLabel({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/DeleteItemLabel", { itemNum: param.itemNum, barcode: param.barcode, lang: param.lang })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printItemLabel({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/item/PrintItemLabel", { barcode: param.barcode, DateExp: param.DateExp ,lang: param.lang })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
  }
};
export default barcodeLabelStore;
